import React from "react";
import GAGroupsContainer from "../../modules/GAGroups/containers/GAGroupsContainer/GAGroupsContainer";

const GAGroups = () => {
  return <GAGroupsContainer />;
};

export default GAGroups;

